import { ActorModel, ActorPhotoModel, ActorPortfolioModel } from '@model';
import Api from './Api';

class _ActorsApi extends Api {
    // Load

    loadMe(): Promise<any> {
        return this.getHttpClient().get('Actors/Me');
    }

    load(idOrToken: number | string, params: any = {}): Promise<any> {
        return this.getLocalHttpClient().get('actors' + (idOrToken ? `/${idOrToken}` : ''), { params });
    }

    loadAll(): Promise<any> {
        return this.getLocalHttpClient().get('actors/all');
    }

    loadList(params: any): Promise<any> {
        console.log(params);
        return this.getLocalHttpClient().get(`actors`, { params });
    }

    loadEmails(params: any): Promise<any> {
        return this.getLocalHttpClient().get(`actors/emails`, { params });
    }

    loadNominations(actor: ActorModel): Promise<any> {
        return this.getHttpClient().get(`Actors/${actor.id}/Nominations`);
    }

    loadContracts(actor: ActorModel): Promise<any> {
        return this.getLocalHttpClient().get(`actors/${actor.id}/contracts`, {
            params: { include: ['project.client'] },
        });
    }

    loadPortfolio(idOrToken: number | string): Promise<any> {
        return this.getLocalHttpClient().get(`actors/${idOrToken}/portfolio`);
    }

    loadGallery(idOrToken: number | string): Promise<any> {
        return this.getLocalHttpClient().get(`actors/${idOrToken}/gallery`);
    }

    loadVideoGallery(idOrToken: number | string): Promise<any> {
        // TODO make new service
        if (typeof idOrToken == 'string') {
            return this.getHttpClient().get(`Actors/Token/${idOrToken}/Gallery`);
        }
        return this.getHttpClient().get(`Actors/${idOrToken}/Gallery`);
    }

    loadVideoRequests(idOrToken: number | string, params: any = {}): Promise<any> {
        return this.getLocalHttpClient().get(`actors/${idOrToken}/videoRequests`, { params });
    }

    loadByToken(token: string): Promise<any> {
        return this.getHttpClient(false).get(`Actors/Token/${token}`);
    }

    loadNominationsByToken(token: string): Promise<any> {
        return this.getHttpClient(false).get(`Actors/Token/${token}/Nominations`);
    }

    loadContractsByToken(token: string): Promise<any> {
        return this.getHttpClient(false).get(`Actors/Token/${token}/Contracts`);
    }

    loadPortfolioByToken(token: string): Promise<any> {
        return this.getHttpClient(false).get(`Actors/Token/${token}/Portfolio`);
    }

    loadGalleryByToken(token: string): Promise<any> {
        return this.getHttpClient(false).get(`Actors/Token/${token}/Gallery`);
    }

    // Save

    saveActor(actor: ActorModel): Promise<any> {
        return this.getHttpClient().put(`/Actors/${actor.id}`, actor);
    }

    saveActorProfile(actor: ActorModel): Promise<any> {
        // TODO: merge after test
        // return this.getHttpClient().put(`/Actors/${actor.id}`, actor.getProfileData());
        return this.getLocalHttpClient().put(`/actors/${actor.id}`, actor.getProfileData());
    }

    // TODO: merge with saveActorProfile
    saveActorLocations(actor: ActorModel): Promise<any> {
        return this.getLocalHttpClient().put(`/actors/${actor.id}`, { locations: actor.locations });
    }

    saveActorGallery(actor: ActorModel): Promise<any> {
        return this.getLocalHttpClient().put(`/actors/${actor.id}`, {
            photos: actor.photos,
        });
    }

    // TODO: remove
    saveActorVideoGallery(actor: ActorModel): Promise<any> {
        return this.getHttpClient().put(`/Actors/${actor.id}`, {
            videoGallery: actor.videoGallery,
        });
    }

    createActorPhoto(actor: ActorModel, { poradie }: any, file: any) {
        const formData = new FormData();
        formData.append('poradie', poradie);
        formData.append('file', file, file.name);
        return this.getLocalHttpClient().post(`/actors/${actor.id}/gallery`, formData);
    }

    updateActorPhoto(photo: ActorPhotoModel, file: any) {
        const formData = new FormData();
        formData.append('poradie', photo.poradie.toString());
        formData.append('file', file, file.name);
        return this.getLocalHttpClient().put(`/gallery/${photo.id}`, formData);
    }

    removeActorPhoto(photo: ActorPhotoModel) {
        return this.getLocalHttpClient().delete(`/gallery/${photo.id}`);
    }

    createActorPortfolio(actor: ActorModel, { file_type, nazov, poradie }: any, file: any) {
        const formData = new FormData();
        formData.append('file_type', file_type);
        formData.append('nazov', nazov);
        formData.append('poradie', poradie);
        formData.append(file_type, file, file.name);
        return this.getLocalHttpClient().post(`/actors/${actor.id}/portfolio`, formData);
    }

    removeActorPortfolio(portfolio: ActorPortfolioModel) {
        return this.getLocalHttpClient().delete(`/portfolio/${portfolio.id}`);
    }

    saveActorPortfolio(actor: ActorModel): Promise<any> {
        return this.getLocalHttpClient().put(`/actors/${actor.id}`, {
            portfolio: actor.portfolio,
        });
    }

    // Other

    shareActor(actor: ActorModel, recipient: string, message: string): Promise<any> {
        return this.getLocalHttpClient().post(`/actors/${actor.id}/share`, { recipient, message });
    }

    startImpersonation(actor: ActorModel) {
        return this.getLocalHttpClient().post(`/actors/${actor.id}/impersonate`);
    }

    stopImpersonation() {
        return this.getLocalHttpClient().delete(`/actors/impersonate`);
    }
}

export const ActorsApi = new _ActorsApi();
